// Generated by scripts/update-schema-types.ts from https://schema.org/version/latest/schemaorg-current-https.jsonld
// Vocabulary SHA-256: 92377e0a6a393b16797ea2b8b09b5c11d7d20c5b9c1e47362f57cd14977612a7
export const organizationTypes = [
  'Organization',
  'AccountingService',
  'AdultEntertainment',
  'Airline',
  'AmusementPark',
  'AnimalShelter',
  'ArchiveOrganization',
  'ArtGallery',
  'Attorney',
  'AutoBodyShop',
  'AutoDealer',
  'AutoPartsStore',
  'AutoRental',
  'AutoRepair',
  'AutoWash',
  'AutomatedTeller',
  'AutomotiveBusiness',
  'Bakery',
  'BankOrCreditUnion',
  'BarOrPub',
  'BeautySalon',
  'BedAndBreakfast',
  'BikeStore',
  'BookStore',
  'BowlingAlley',
  'Brewery',
  'CafeOrCoffeeShop',
  'Campground',
  'Casino',
  'ChildCare',
  'ClothingStore',
  'CollegeOrUniversity',
  'ComedyClub',
  'ComputerStore',
  'Consortium',
  'ConvenienceStore',
  'Cooperative',
  'Corporation',
  'CovidTestingFacility',
  'DanceGroup',
  'DaySpa',
  'Dentist',
  'DepartmentStore',
  'DiagnosticLab',
  'Distillery',
  'DryCleaningOrLaundry',
  'EducationalOrganization',
  'Electrician',
  'ElectronicsStore',
  'ElementarySchool',
  'EmergencyService',
  'EmploymentAgency',
  'EntertainmentBusiness',
  'ExerciseGym',
  'FastFoodRestaurant',
  'FinancialService',
  'FireStation',
  'Florist',
  'FoodEstablishment',
  'FundingAgency',
  'FundingScheme',
  'FurnitureStore',
  'GardenStore',
  'GasStation',
  'GeneralContractor',
  'GolfCourse',
  'GovernmentOffice',
  'GovernmentOrganization',
  'GroceryStore',
  'HVACBusiness',
  'HairSalon',
  'HardwareStore',
  'HealthAndBeautyBusiness',
  'HealthClub',
  'HighSchool',
  'HobbyShop',
  'HomeAndConstructionBusiness',
  'HomeGoodsStore',
  'Hospital',
  'Hostel',
  'Hotel',
  'HousePainter',
  'IceCreamShop',
  'IndividualPhysician',
  'InsuranceAgency',
  'InternetCafe',
  'JewelryStore',
  'LegalService',
  'Library',
  'LibrarySystem',
  'LiquorStore',
  'LocalBusiness',
  'Locksmith',
  'LodgingBusiness',
  'MedicalBusiness',
  'MedicalClinic',
  'MedicalOrganization',
  'MensClothingStore',
  'MiddleSchool',
  'MobilePhoneStore',
  'Motel',
  'MotorcycleDealer',
  'MotorcycleRepair',
  'MovieRentalStore',
  'MovieTheater',
  'MovingCompany',
  'MusicGroup',
  'MusicStore',
  'NGO',
  'NailSalon',
  'NewsMediaOrganization',
  'NightClub',
  'Notary',
  'OfficeEquipmentStore',
  'OnlineBusiness',
  'OnlineMarketplace',
  'OnlineStore',
  'Optician',
  'OutletStore',
  'PawnShop',
  'PerformingGroup',
  'PetStore',
  'Pharmacy',
  'Physician',
  'PhysiciansOffice',
  'Plumber',
  'PoliceStation',
  'PoliticalParty',
  'PostOffice',
  'Preschool',
  'ProfessionalService',
  'Project',
  'PublicSwimmingPool',
  'RadioStation',
  'RealEstateAgent',
  'RecyclingCenter',
  'ResearchOrganization',
  'ResearchProject',
  'Resort',
  'Restaurant',
  'RoofingContractor',
  'School',
  'SearchRescueOrganization',
  'SelfStorage',
  'ShoeStore',
  'ShoppingCenter',
  'SkiResort',
  'SportingGoodsStore',
  'SportsActivityLocation',
  'SportsClub',
  'SportsOrganization',
  'SportsTeam',
  'StadiumOrArena',
  'Store',
  'TattooParlor',
  'TelevisionStation',
  'TennisComplex',
  'TheaterGroup',
  'TireShop',
  'TouristInformationCenter',
  'ToyStore',
  'TravelAgency',
  'VacationRental',
  'VeterinaryCare',
  'WholesaleStore',
  'Winery',
  'WorkersUnion',
] as const;
